$(document).ready(function () {  
  if($('body').hasClass('template-product')){
    if($(window).width() < 769){
      $('.product-block.variant_block').insertBefore('.product-block.product-dec');
    }else{
      // $('.product-block.variant_block').insertAfter('.product-block.product-block--price');
    }
  }

  
  $("ul.site-nav li.site-nav__item .site-nav__dropdown .grid__item ").each(function () {
      if ($(this).find('.grandclile-link-list').height() > 490) {
        $(this).find(".view-all-btn-megamanu-link").removeClass("hide");
        $(this).find('.grandclile-link-list').css("height", '490px');
      }
  });

   $('.view-all_btn').click(function(){
    $(this).parents('.grid').find(".grandclile-link-list").css("height", '100%');
    $(this).hide();
  $(".view-all-btn-megamanu-link").addClass("hide");
 });


    $('.mobile-nav a.mobile-nav__link.custom-menu-dower').click(function(){
      $('.mobile-nav a.mobile-nav__link.custom-menu-dower').removeClass('active_tab');
      $(this).addClass('active_tab');
        $('.custome-manu-list .mobile-nav__sublist.custome_mobile_secondderuy_menu').addClass('hide');
        // console.log(`#${$(this).attr('aria-controls')}`);
        $('#'+$(this).attr('aria-controls')).removeClass('hide');
       $('#'+$(this).attr('aria-controls')).find('.collapsible-trigger').each(function(){
          if ($(this).hasClass('is-open')){
          $(this).trigger('click');
          } 
          $(this).trigger('click');         
          });      
       $('#'+$(this).attr('aria-controls')).css("height", 'auto');
    });

  $('#SiteHeader .js-drawer-open-nav').click(function(){
    console.log("mobile-drower-open");
   $('.custome-manu-list .mobile-nav__child-item .collapsible-trigger').trigger('click');
    $('.mobile-nav .custom-menu-dower').first().trigger('click');
  });

  $(".site-nav--has-dropdown").hover(function(){
    $("body").addClass("open_megamanu")
      $("html").addClass("open_megamanu")
     if($('body').hasClass('template-index')){
      if($('#SiteHeader').hasClass('not_sticky')){
        if($('#HeaderWrapper').hasClass('is-light')){
          $('#HeaderWrapper').removeClass('is-light');
          $('#HeaderWrapper').removeClass('header-wrapper--sticky');
        }
      }
     }
  }, function(){
  $("body").removeClass("open_megamanu")
    $("html").removeClass("open_megamanu")
    if($('body').hasClass('template-index')){
      if($('#SiteHeader').hasClass('not_sticky')){
        $('#HeaderWrapper').addClass('is-light');
        $('#HeaderWrapper').addClass('header-wrapper--sticky');
      }
    }
  });

  if ($(window).width() < 960) {
$( ".collection-filter-top" ).insertBefore( ".collection-category" );
$( ".collection-header" ).insertAfter( ".collection-category" );
  };

    if ($(window).width() < 769) {
// $( ".product-block.product-block--header , .product-block.product-text , .product-block.product-block--price " ).insertBefore( ".product-single__sticky" );
// $( ".collection-header" ).insertAfter( ".collection-category" );
  };



  
 //  var waypoints = $('.product__submit__area.check-up').waypoint({
 //        handler: function(direction) {
 //            if(direction === 'up'){
 //                $('.product__submit__area').addClass('is--active');
 //            } else {
 //                $('.product__submit__area').removeClass('is--active');
 //            }
 //        },
 //        offset: 'bottom-in-view'
 //      });
  
 // var waypoints = $('.product__submit__area').waypoint({
 //        handler: function(direction) {
 //            if(direction === 'down'){
 //                $('.product__submit__area').addClass('is--active');
 //            } else {
 //                $('.product__submit__area').removeClass('is--active');
 //            }
 //        },
 //        offset: 'bottom-in-view'
 //      });

      $('.product--submit-button.btn-sticky').click(function(){
        var formid =  '#'+$(this).attr('data_form_id');
        console.log(formid);
        $(formid).find('.product__submit__area button.add-to-cart').click();
      });


  //product page pre_order
    $(document).on('click','.product-buy-button .pre_order', function(e){
      e.preventDefault();
      $(".pop-up_wrap").addClass("active");
      $("body").addClass("active");
    });
    $(document).on('click','.main_pop_up .close_pop_btn,.main_pop_up .cancel_btn', function(){
      $(".pop-up_wrap").removeClass("active");
      $("body").removeClass("active");
    });
   $(document).on('click','.main_pop_up .ok_btn', function(){
      setTimeout(function(){    
      $(".pop-up_wrap").removeClass("active");
      $("body").removeClass("active");
      $(".product-buy-button button.add-to-cart").removeClass("pre_order");
      $(".product__block__popup").removeClass("pop-up_wrap");
        $('.product__submit__area button.add-to-cart').click();
      },500);
    });

    //cart remove pre_order add
   $(document).on('click','#CartDrawer .js-qty__wrapper .js-qty__adjust',function(){
     setTimeout(function() {
       if($('body').hasClass('template-product')){
         var product_id = $('.product-section').attr('data-product-id');
          jQuery.getJSON('/cart.js', function(cart) {
              let cartData = cart.items;
               var prod_in = false;
              for(var i=0;i<cartData.length;i++){
               if(cartData[i].product_id == product_id){
                 var prod_in = true;
                } 
              }
  
            if(!prod_in){
              if($(".product-buy-button button.add-to-cart").hasClass('has_pre_order')){
                $(".product-buy-button button.add-to-cart").addClass("pre_order");
                $(".product__block__popup").addClass("pop-up_wrap");
              }
            }
          });
       }
     }, 1200);
   });
  //end product page pre_order
  if($('body').hasClass('template-product')){
    $(window).scroll(function() {
      if($(window).scrollTop() >= $('.add-to-cart').offset().top){
             $(".product__submit__area").addClass("is--active");
      }
      if($(window).scrollTop() < $('.add-to-cart').offset().top){
            $(".product__submit__area").removeClass("is--active");
      }
    });
  }
  
});

$(document).ready(function() {
  var divHeight = $('.announcement_bar-sec').height();
  $(':root').css('--announcement-bar-height', divHeight + 'px');
});

